<template>
  <div class="header">
    <notice-icon-view class="notice" />
    <a-dropdown class="lang-pick">
      <a-icon type="global" />
      <a-menu
        slot="overlay"
        @click="localeChange"
        :selectedKeys="[$route.query.locale || 'zhCN']"
      >
        <a-menu-item key="zhCN">
          中文
        </a-menu-item>
        <a-menu-item key="enUS">
          English
        </a-menu-item>
        <a-menu-item key="jaJP">
          Japanese
        </a-menu-item>        
      </a-menu>
    </a-dropdown>
    <img src="@/assets/exit.png" @click="logoff" :title="$t('message')['User.logout']"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NoticeIconView from "@/components/GlobalHeader/NoticeIconView";
export default {
  components: { NoticeIconView },
  methods: {
    ...mapActions("login", ["logout"]),
    localeChange({ key }) {
      this.$router.push({ query: { ...this.$route.query, locale: key } });
      this.$i18n.locale = key;
    },
    logoff() {
      this.logout({}).then(() => {
          console.log("logout");
        });
    }
  }
};
</script>

<style scoped lang="less">
.header {
  float: right;
  margin-right: 30px;

  img {
    margin-left: 20px;
    width: 20px;
    height: 15px;
  }

  .notice {
    margin-left: 20px;
    width: 20px;
    height: 15px;
  }

  .lang-pick {
    margin-left: 30px;
    width: 20px;
    height: 15px;    
  }

}
</style>
